"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Jwt = void 0;
const jsonwebtoken_1 = __importDefault(require("jsonwebtoken"));
const Log_1 = __importDefault(require("../Log"));
class Jwt {
    constructor(token) {
        this._rawToken = token;
        try {
            this._token = jsonwebtoken_1.default.decode(this._rawToken);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const { sub, aud, iss, type, iat, exp, jti } = this._token;
            this._subject = sub;
            this._audience = aud;
            this._issuer = iss;
            this._type = type;
            this._id = jti;
            this._issuedAt = new Date(iat * 1000);
            this._expiry = new Date(exp * 1000);
        }
        catch (error) {
            Log_1.default.error(`Failed to parse token ${token}. Error: ${error}`);
        }
    }
    get id() {
        return this._id;
    }
    get token() {
        return this._token;
    }
    get rawToken() {
        return this._rawToken;
    }
    get subject() {
        return this._subject;
    }
    get audience() {
        return this._audience;
    }
    get issuer() {
        return this._issuer;
    }
    get type() {
        return this._type;
    }
    get issuedAt() {
        return this._issuedAt;
    }
    get expiry() {
        return this._expiry;
    }
    get isExpired() {
        return this._expiry < new Date(Date.now());
    }
    isValid() {
        return !!(this._subject && this._audience && this._issuer && !this.isExpired);
    }
}
exports.Jwt = Jwt;
//# sourceMappingURL=Jwt.js.map